export const kenhBan = {
  nhom: {
    BAN_OFF: 'Offline',
    BAN_ON: 'Online',
  },
  labels: {
    TU_GIAO: 'Self delivery',
    VAN_CHUYEN_THU_3: '3rd-party carrier',
    SHOPEE: 'Shopee',
    TIKTOK_SHOP: 'TikTok',
    LAZADA: 'Lazada',
    FACEBOOK_ZALO: 'Facebook / Zalo',
    WEBSITE: 'Website',
  },
}
